import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HubIframeComponent } from './hub-iframe.component';

@NgModule({
    imports: [ CommonModule ],
    exports: [ HubIframeComponent ],
    declarations: [ HubIframeComponent ],
})
export class HubIframeModule {}
